module.exports = __webpack_public_path__ + "static/img/12.0cc558c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nbaip/sku/T恤/12.png
// module id = 9+HU
// module chunks = 0